import moment from 'moment';
import 'moment/dist/locale/es';
import { useTranslation } from 'react-i18next';
import { eField } from '../../../../../../Chat.enum.ts';
import { parseAction, parseField } from '../../../../../../Chat.functions.ts';
import { useChatContext } from '../../../../../../Chat.hook.ts';
import { Change } from '../../../../../../Chat.types.ts';
import './Record.styles.scss';

// Reserved author id stamped by leads-service on history events the Lead Agent
// (SmartLeadBot) actually produced. A null/unknown author is a system or
// organic action (e.g. inbound-message lead creation) and must NOT be
// attributed to the agent — the agent has no lead-creation capability.
// Must match LEAD_AGENT_AUTHOR_UUID in leads-service (LeadObserver). (RET-1203)
const LEAD_AGENT_AUTHOR_ID = '00000000-0000-0000-0000-00000000b07b';

export default function Record(props: Change) {
  const { selectedChat } = useChatContext();
  const leadUser = selectedChat?.lead?.users ?? [];
  const { t, i18n } = useTranslation('chat/chat');

  function getChangedByUser() {
    if (props.changedBy === LEAD_AGENT_AUTHOR_ID) {
      return `${t('leadCard.agent')} 🤖`;
    }
    if (!props.changedBy) {
      return 'Leadsales 🚀';
    }
    return (
      leadUser.find((user) => user.auth_id === props.changedBy)?.name ??
      'Leadsales 🚀'
    );
  }
  return (
    <div className="Record">
      <div className="Record__Content">
        <span className="Record__Content__Name">{getChangedByUser()}</span>
        <p className="Record__Content__Text">
          {t(`records.actions.${parseAction(props.type)}`)}{' '}
          {t(`records.labels.${parseField(props.field)}`)}{' '}
          {props.field === eField.ARCHIVED ? (
            <>
              {props.previousValue ? t('records.to') : null}{' '}
              <span className="italic">
                {props.newValue === '0'
                  ? t('records.statusArchived')
                  : t('records.statusActive')}
              </span>
            </>
          ) : (
            <>
              {props.previousValue ? t('records.from') : null}{' '}
              <span className="italic">{props.previousValue}</span>{' '}
              {props.newValue ? t('records.to') : null}{' '}
              <span className="italic">{props.newValue}</span>
            </>
          )}
        </p>
      </div>
      <div className="Record__DateTime">
        <p>
          {moment(props.createdAt)
            .locale(i18n.language)
            .format(
              `dddd, D [${t('records.of')}] MMMM [${t('records.of')}] YYYY`,
            )}
          <span> {t('records.at')} </span>
          {moment(props.createdAt).format('h:mm a')}
        </p>
      </div>
    </div>
  );
}
